/*
  ЦИФРОВОЙ ДИАК ЗФ — SUBTASK STATUS METADATA
  Один источник истины для подписей, цветов и иконок статусов подзадач.
*/

import type { LucideIcon } from "lucide-react";
import {
  CheckCircle2,
  Circle,
  CircleDashed,
  CircleDot,
  LoaderCircle,
} from "lucide-react";
import type { BacklogSubtaskStatus } from "@/store/projectStore";

export interface SubtaskStatusMeta {
  value: BacklogSubtaskStatus;
  label: string;
  /** Основной цвет (иконка/индикатор/чип). */
  color: string;
  /** Полупрозрачный фон для чипа/dot. */
  tint: string;
  /** Lucide-иконка статуса. */
  icon: LucideIcon;
  /** Tailwind-класс цвета текста для иконки. */
  textClass: string;
  /** Дополнительный класс для иконки (например, анимация для in_progress). */
  iconClass?: string;
  /** Короткое объяснение статуса для подсказок. */
  hint: string;
}

export const SUBTASK_STATUS_META: Record<BacklogSubtaskStatus, SubtaskStatusMeta> = {
  backlog: {
    value: "backlog",
    label: "Бэклог",
    color: "#94a3b8",
    tint: "#94a3b822",
    icon: CircleDashed,
    textClass: "text-slate-400 dark:text-slate-500",
    hint: "Будущая работа, ещё не запланирована к ближайшему спринту",
  },
  todo: {
    value: "todo",
    label: "Сделать",
    color: "#64748b",
    tint: "#64748b22",
    icon: Circle,
    textClass: "text-slate-500 dark:text-slate-400",
    hint: "Запланировано, ждёт исполнителя",
  },
  in_progress: {
    value: "in_progress",
    label: "В работе",
    color: "#3b82f6",
    tint: "#3b82f622",
    icon: LoaderCircle,
    textClass: "text-blue-500 dark:text-blue-400",
    hint: "Кто-то активно работает над этим",
  },
  review: {
    value: "review",
    label: "На оценке",
    color: "#f59e0b",
    tint: "#f59e0b22",
    icon: CircleDot,
    textClass: "text-amber-500 dark:text-amber-400",
    hint: "Готово к проверке / ревью / приёмке",
  },
  done: {
    value: "done",
    label: "Сделано",
    color: "#10b981",
    tint: "#10b98122",
    icon: CheckCircle2,
    textClass: "text-emerald-500 dark:text-emerald-400",
    hint: "Подзадача выполнена",
  },
};

export const SUBTASK_STATUS_ORDER: BacklogSubtaskStatus[] = [
  "backlog",
  "todo",
  "in_progress",
  "review",
  "done",
];
